import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=74ef8b2f&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ef8b2f')) {
      api.createRecord('74ef8b2f', component.options)
    } else {
      api.reload('74ef8b2f', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=74ef8b2f&", function () {
      api.rerender('74ef8b2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aLBJLH68LJXx/JS/comp/IncreaseNumber.vue"
export default component.exports